const RATING_ALIASES = {
  NI: 'needsimprovement',
  'ME-': 'meetsexpectations-',
  ME: 'meetsexpectations',
  'ME+': 'meetsexpectations+',
  'EE-': 'exceedsexpectations-',
  EE: 'exceedsexpectations',
  'EE+': 'exceedsexpectations+',
  E: 'excels',
  EX: 'excels'
}

function normalizedRating (value) {
  const text = String(value || '').trim()
  return RATING_ALIASES[text.toUpperCase()] || text.toLowerCase().replace(/[^a-z0-9+-]/g, '')
}

export function requiresVietnamMilwaukeeJustification (suggestedRating, manualRating) {
  const suggested = normalizedRating(suggestedRating)
  const manual = normalizedRating(manualRating)
  if (!suggested || !manual) return false
  const isHighRating = rating => (
    rating.startsWith('exceedsexpectation') ||
    rating.startsWith('excel')
  )
  return suggested !== manual || isHighRating(suggested) || isHighRating(manual)
}

export const vietnamMilwaukeeJustificationMinLength = appraisal => (
  Math.max(1, Number(appraisal?.session_rating_justification_min_length) || 10)
)
